import { NotificationProgrammatic as Notification } from "buefy";

export function consoleHandlerError({
    error = null,
    refFields = Object,
    customDefaultMessage = null,
    empty = false,
    indefinite = false,
}) {
    console.error(JSON.stringify(error));
    console.error(
        JSON.stringify(error?.response?.data) || "No hay detalle del error"
    );
    console.error(error?.response?.status || "Sin retorno del estado");
    console.error(error?.response?.statusText || "Sin detalle del estado");
    let msg = empty ? null : error?.response?.data || null;
    showErrorMessage(msg, refFields, customDefaultMessage, indefinite);
    throw error;
}

export function notificate(
    message,
    type,
    position = "is-top-right",
    indefinite = false,
    duration = 5000
) {
    Notification.open({
        message: message,
        type: type,
        position: position,
        ...(!indefinite && {
            duration: duration,
        }),
        ...(indefinite && {
            indefinite: indefinite,
        }),
    });
}

function showErrorMessage(
    innerMessage = null,
    refFields = Object,
    customDefaultMessage = null,
    indefinite = false,
) {
    let message = "";
    if (isObject(innerMessage)) {
        let additionalKeys = ["counterpart", "owner", "company"];
        let expectedKeys = Object.keys(refFields).concat(additionalKeys);
        Object.entries(innerMessage).forEach(function([key, value]) {
            if (expectedKeys.includes(key)) {
                message = setFormError(
                    refFields,
                    key,
                    value,
                    customDefaultMessage
                );
            } else {
                let firstMessage = Array.isArray(value) ? value[0] : value;
                message += showErrorMessage(
                    firstMessage, refFields, null, indefinite
                );
            }
        });
        return message;
    } else {
        return notificateInnerMessageOrDefault(
            innerMessage,
            customDefaultMessage,
            indefinite,
        );
    }
}

function setFormError(
    refFields,
    refName,
    errorMessage,
    customDefaultMessage = null
) {
    if (isObject(errorMessage) && !Array.isArray(errorMessage)) {
        Object.entries(errorMessage).forEach(function([key, value]) {
            let fieldName = `${refName}_${key}`;
            return setFormError(
                refFields,
                fieldName,
                value,
                customDefaultMessage
            );
        });
    } else {
        return fillFormErrorElementOrDefault(
            refFields,
            refName,
            errorMessage,
            customDefaultMessage
        );
    }
}

function fillFormErrorElementOrDefault(
    refFields,
    refName,
    message,
    defaultMessage = null
) {
    let msg = "";
    if (refFields[refName] && refFields[refName].$children) {
        let msg = defaultMessage || message;
        refFields[refName].$children[0].setErrors(msg);
    } else {
        let field = translateFieldName(refName);
        msg = notificateInnerMessageOrDefault(`${field}: ${message}`);
    }
    return msg;
}

function notificateInnerMessageOrDefault(
    message = null,
    customDefaultMessage = null,
    indefinite = false,
) {
    let defaultMessage = `
        <p class="m-0">
            <strong>Lo sentimos, estamos teniendo un pequeño error.</strong>
        </p><br>
        <p class="m-0">Ya estamos trabajando para mejorar la situación y
            nos tomará un momento para solucionarlo.
        </p>
    `;
    let msg = customDefaultMessage || message || defaultMessage;
    if (msg.includes("Server Error (500)")) {
        msg = defaultMessage;
    }
    notificate(`<p class="m-0">${msg}</p>`, "is-danger is-light", "is-top-right", indefinite);
}

function translateFieldName(fieldName) {
    return {
        financial_entity: "Institución Financiera",
        amount: "Monto",
    }[fieldName];
}

function isObject(param) {
    return typeof param === "object" && param !== null;
}
